import { roundToDecimals } from './bar-normalizer';
import { isIntradayResolution, resolutionDurationSeconds } from './resolutions';

export class CandleAggregator {
  constructor(resolution, seedBar = null, priceDecimals) {
    this.durationMs = resolutionDurationSeconds(resolution) * 1000;
    this.rollsOver = isIntradayResolution(resolution);
    this.alignmentMs = seedBar?.time || 0;
    this.priceDecimals = priceDecimals;
    this.currentBar = seedBar ? { ...seedBar } : null;
    this.volumeBaseline = null;
    this.lastTick = null;
  }

  getCurrentBar() {
    return this.currentBar ? { ...this.currentBar } : null;
  }

  bucketStart(timeMs) {
    return this.alignmentMs + Math.floor((timeMs - this.alignmentMs) / this.durationMs) * this.durationMs;
  }

  deriveVolume(tick) {
    if (tick.volume === undefined) return this.currentBar?.volume;
    if (this.volumeBaseline === null || tick.volume < this.volumeBaseline) {
      this.volumeBaseline = tick.volume;
      return 0;
    }
    return tick.volume - this.volumeBaseline;
  }

  apply(rawTick) {
    if (!Number.isFinite(rawTick?.price) || rawTick.price <= 0 || !Number.isFinite(rawTick.timeMs)) {
      return null;
    }
    const tick = { ...rawTick, price: roundToDecimals(rawTick.price, this.priceDecimals) };
    if (
      this.lastTick &&
      this.lastTick.timeMs === tick.timeMs &&
      this.lastTick.price === tick.price &&
      this.lastTick.volume === tick.volume
    ) {
      return null;
    }
    if (!this.currentBar) return this.openBar(this.bucketStart(tick.timeMs), tick);
    if (this.rollsOver) {
      const bucket = this.bucketStart(tick.timeMs);
      if (bucket > this.currentBar.time) return this.openBar(bucket, tick);
      if (bucket < this.currentBar.time) return null;
    } else if (tick.timeMs < this.currentBar.time) {
      return null;
    }
    const volume = this.deriveVolume(tick);
    this.currentBar = {
      ...this.currentBar,
      high: Math.max(this.currentBar.high, tick.price),
      low: Math.min(this.currentBar.low, tick.price),
      close: tick.price,
      volume,
    };
    this.lastTick = tick;
    return { bar: { ...this.currentBar }, isNewBar: false };
  }

  openBar(time, tick) {
    this.volumeBaseline = tick.volume ?? null;
    this.currentBar = {
      time,
      open: tick.price,
      high: tick.price,
      low: tick.price,
      close: tick.price,
      volume: tick.volume === undefined ? undefined : 0,
    };
    this.lastTick = tick;
    return { bar: { ...this.currentBar }, isNewBar: true };
  }
}
